// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

// The tagged union or sum type for the algebraic type `ActorType`.
export const ActorType = __t.enum("ActorType", {
  Player: __t.unit(),
  Agent: __t.unit(),
});
export type ActorType = __Infer<typeof ActorType>;

// The tagged union or sum type for the algebraic type `AnchorType`.
export const AnchorType = __t.enum("AnchorType", {
  Twin: __t.unit(),
  Relationship: __t.unit(),
  WorldPosition: __t.unit(),
  GraphPosition: __t.unit(),
  Viewport: __t.unit(),
});
export type AnchorType = __Infer<typeof AnchorType>;

export const Annotation = __t.object("Annotation", {
  annotationId: __t.u64(),
  sessionId: __t.u64(),
  createdByPresenceId: __t.u64(),
  createdByName: __t.string(),
  get createdByActorType() {
    return ActorType;
  },
  get anchorType() {
    return AnchorType;
  },
  anchorElementId: __t.option(__t.string()),
  worldX: __t.option(__t.f64()),
  worldY: __t.option(__t.f64()),
  worldZ: __t.option(__t.f64()),
  content: __t.string(),
  get annotationType() {
    return AnnotationType;
  },
  get visibility() {
    return Visibility;
  },
  visibleToIdentitiesJson: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  resolved: __t.bool(),
  resolvedBy: __t.option(__t.identity()),
  resolvedAt: __t.option(__t.timestamp()),
});
export type Annotation = __Infer<typeof Annotation>;

// The tagged union or sum type for the algebraic type `AnnotationType`.
export const AnnotationType = __t.enum("AnnotationType", {
  Comment: __t.unit(),
  Question: __t.unit(),
  Issue: __t.unit(),
  Suggestion: __t.unit(),
  AgentInsight: __t.unit(),
});
export type AnnotationType = __Infer<typeof AnnotationType>;

export const AvatarState = __t.object("AvatarState", {
  presenceId: __t.u64(),
  sessionId: __t.u64(),
  positionX: __t.f64(),
  positionY: __t.f64(),
  positionZ: __t.f64(),
  rotationPitch: __t.f32(),
  rotationYaw: __t.f32(),
  rotationRoll: __t.f32(),
  lookX: __t.f32(),
  lookY: __t.f32(),
  lookZ: __t.f32(),
  velocityX: __t.f32(),
  velocityY: __t.f32(),
  velocityZ: __t.f32(),
  sequenceNumber: __t.u64(),
  lastUpdate: __t.timestamp(),
  geoLat: __t.option(__t.f64()),
  geoLon: __t.option(__t.f64()),
  geoElev: __t.option(__t.f64()),
  headingDeg: __t.option(__t.f32()),
  pitchDeg: __t.option(__t.f32()),
  vfovDeg: __t.option(__t.f32()),
  aspect: __t.option(__t.f32()),
});
export type AvatarState = __Infer<typeof AvatarState>;

export const ChatAudioEvent = __t.object("ChatAudioEvent", {
  sessionId: __t.u64(),
  messageId: __t.u64(),
  sentenceIndex: __t.u32(),
  totalSentences: __t.u32(),
  mimeType: __t.string(),
  sampleRate: __t.u32(),
  audioBytes: __t.byteArray(),
  durationMs: __t.u32(),
  isFinal: __t.bool(),
  createdAt: __t.timestamp(),
  downloadUrl: __t.string(),
});
export type ChatAudioEvent = __Infer<typeof ChatAudioEvent>;

export const ChatMessage = __t.object("ChatMessage", {
  messageId: __t.u64(),
  sessionId: __t.u64(),
  senderIdentity: __t.identity(),
  senderName: __t.string(),
  get senderActorType() {
    return ActorType;
  },
  content: __t.string(),
  createdAt: __t.timestamp(),
  editedAt: __t.option(__t.timestamp()),
  get tag() {
    return ChatMessageTag;
  },
});
export type ChatMessage = __Infer<typeof ChatMessage>;

// The tagged union or sum type for the algebraic type `ChatMessageTag`.
export const ChatMessageTag = __t.enum("ChatMessageTag", {
  Standard: __t.unit(),
  Caption: __t.unit(),
});
export type ChatMessageTag = __Infer<typeof ChatMessageTag>;

// The tagged union or sum type for the algebraic type `ClientType`.
export const ClientType = __t.enum("ClientType", {
  Unknown: __t.unit(),
  Webclient: __t.unit(),
  UnrealClient: __t.unit(),
  AgentProcess: __t.unit(),
});
export type ClientType = __Infer<typeof ClientType>;

export const CommandLocation = __t.object("CommandLocation", {
  latitude: __t.f64(),
  longitude: __t.f64(),
  altitude: __t.option(__t.f64()),
});
export type CommandLocation = __Infer<typeof CommandLocation>;

// The tagged union or sum type for the algebraic type `CommandTarget`.
export const CommandTarget = __t.enum("CommandTarget", {
  Twin: __t.string(),
  get Location() {
    return CommandLocation;
  },
});
export type CommandTarget = __Infer<typeof CommandTarget>;

// The tagged union or sum type for the algebraic type `CommandType`.
export const CommandType = __t.enum("CommandType", {
  HighlightTwin: __t.unit(),
  HighlightGeo: __t.unit(),
  FlyToTwin: __t.unit(),
  FlyToLocation: __t.unit(),
  LookAtTwin: __t.unit(),
  LookAtLocation: __t.unit(),
  FlyAndLookAt: __t.unit(),
  OrbitTwin: __t.unit(),
  FollowTwin: __t.unit(),
  StopCamera: __t.unit(),
  SelectTwins: __t.unit(),
  ClearSelection: __t.unit(),
  SetTransparency: __t.unit(),
  FlyAlongPath: __t.unit(),
  SetCameraMode: __t.unit(),
  ShowRelationships: __t.unit(),
  HideRelationships: __t.unit(),
  ShowTwinInfo: __t.unit(),
});
export type CommandType = __Infer<typeof CommandType>;

// The tagged union or sum type for the algebraic type `CursorPosition`.
export const CursorPosition = __t.enum("CursorPosition", {
  get Relative2D() {
    return CursorRelative2D;
  },
  get Relative3D() {
    return CursorRelative3D;
  },
  get Spatial() {
    return CursorSpatial;
  },
  Hidden: __t.unit(),
});
export type CursorPosition = __Infer<typeof CursorPosition>;

export const CursorRelative2D = __t.object("CursorRelative2D", {
  frame: __t.string(),
  x: __t.f32(),
  y: __t.f32(),
});
export type CursorRelative2D = __Infer<typeof CursorRelative2D>;

export const CursorRelative3D = __t.object("CursorRelative3D", {
  frame: __t.string(),
  x: __t.f32(),
  y: __t.f32(),
  z: __t.f32(),
});
export type CursorRelative3D = __Infer<typeof CursorRelative3D>;

export const CursorSpatial = __t.object("CursorSpatial", {
  latitude: __t.f64(),
  longitude: __t.f64(),
  elevation: __t.f64(),
});
export type CursorSpatial = __Infer<typeof CursorSpatial>;

// The tagged union or sum type for the algebraic type `ElementType`.
export const ElementType = __t.enum("ElementType", {
  Twin: __t.unit(),
  Relationship: __t.unit(),
  TelemetryStream: __t.unit(),
  Annotation: __t.unit(),
  GraphNode: __t.unit(),
  GraphEdge: __t.unit(),
  Viewport3DObject: __t.unit(),
});
export type ElementType = __Infer<typeof ElementType>;

export const HighlightCleanupSchedule = __t.object("HighlightCleanupSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type HighlightCleanupSchedule = __Infer<typeof HighlightCleanupSchedule>;

export const HighlightState = __t.object("HighlightState", {
  highlightId: __t.u64(),
  sessionId: __t.u64(),
  createdByPresenceId: __t.u64(),
  get createdByActorType() {
    return ActorType;
  },
  get highlightType() {
    return HighlightType;
  },
  get elementType() {
    return ElementType;
  },
  elementId: __t.string(),
  color: __t.string(),
  pulse: __t.bool(),
  durationMs: __t.option(__t.u32()),
  message: __t.option(__t.string()),
  priority: __t.u8(),
  createdAt: __t.timestamp(),
  expiresAt: __t.option(__t.timestamp()),
});
export type HighlightState = __Infer<typeof HighlightState>;

// The tagged union or sum type for the algebraic type `HighlightType`.
export const HighlightType = __t.enum("HighlightType", {
  Selection: __t.unit(),
  Attention: __t.unit(),
  Warning: __t.unit(),
  Guidance: __t.unit(),
  Annotation: __t.unit(),
});
export type HighlightType = __Infer<typeof HighlightType>;

export const InfraBrokerConfig = __t.object("InfraBrokerConfig", {
  id: __t.u32(),
  brokerUrl: __t.string(),
  configuredAt: __t.timestamp(),
});
export type InfraBrokerConfig = __Infer<typeof InfraBrokerConfig>;

export const ManagedSessionService = __t.object("ManagedSessionService", {
  identity: __t.identity(),
});
export type ManagedSessionService = __Infer<typeof ManagedSessionService>;

export const MpDispatchConfig = __t.object("MpDispatchConfig", {
  id: __t.u32(),
  stdbToken: __t.string(),
  stdbHost: __t.string(),
  mpModuleName: __t.string(),
  updatedAt: __t.timestamp(),
});
export type MpDispatchConfig = __Infer<typeof MpDispatchConfig>;

export const OrgModuleAdminLineage = __t.object("OrgModuleAdminLineage", {
  id: __t.u32(),
  mintedBy: __t.identity(),
});
export type OrgModuleAdminLineage = __Infer<typeof OrgModuleAdminLineage>;

// The tagged union or sum type for the algebraic type `OrgModuleRole`.
export const OrgModuleRole = __t.enum("OrgModuleRole", {
  Reader: __t.unit(),
  Writer: __t.unit(),
});
export type OrgModuleRole = __Infer<typeof OrgModuleRole>;

export const OrgModuleServiceConfig = __t.object("OrgModuleServiceConfig", {
  id: __t.u32(),
  adminIdentity: __t.identity(),
});
export type OrgModuleServiceConfig = __Infer<typeof OrgModuleServiceConfig>;

export const OrgModuleUser = __t.object("OrgModuleUser", {
  identity: __t.identity(),
  get role() {
    return OrgModuleRole;
  },
});
export type OrgModuleUser = __Infer<typeof OrgModuleUser>;

export const PlayerCommandEvent = __t.object("PlayerCommandEvent", {
  sessionId: __t.u64(),
  sourcePresenceId: __t.u64(),
  targetPresenceId: __t.option(__t.u64()),
  get commandType() {
    return CommandType;
  },
  twinIds: __t.array(__t.string()),
  propertyNames: __t.array(__t.string()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  altitude: __t.option(__t.f64()),
  durationMs: __t.option(__t.u32()),
  message: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  get flyTarget() {
    return __t.option(CommandTarget);
  },
  get lookAtTarget() {
    return __t.option(CommandTarget);
  },
  lookAtBlendStart: __t.option(__t.f32()),
  distance: __t.option(__t.f32()),
  pitch: __t.option(__t.f32()),
  rotateSpeed: __t.option(__t.f32()),
  opacity: __t.option(__t.f32()),
  get path() {
    return __t.option(__t.array(CommandLocation));
  },
  cameraMode: __t.option(__t.string()),
  telemetryNames: __t.option(__t.array(__t.string())),
});
export type PlayerCommandEvent = __Infer<typeof PlayerCommandEvent>;

export const PlayerFocus = __t.object("PlayerFocus", {
  presenceId: __t.u64(),
  sessionId: __t.u64(),
  currentTab: __t.string(),
  currentRoute: __t.string(),
  currentViewId: __t.option(__t.string()),
  focusedTwinId: __t.option(__t.string()),
  focusedTwinDtmi: __t.option(__t.string()),
  selectedTwinIdsJson: __t.string(),
  graphCenterX: __t.option(__t.f64()),
  graphCenterY: __t.option(__t.f64()),
  graphZoom: __t.option(__t.f32()),
  viewedStreamsJson: __t.string(),
  timeRangeStart: __t.option(__t.timestamp()),
  timeRangeEnd: __t.option(__t.timestamp()),
  lastUpdate: __t.timestamp(),
});
export type PlayerFocus = __Infer<typeof PlayerFocus>;

export const PresenceCleanupSchedule = __t.object("PresenceCleanupSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type PresenceCleanupSchedule = __Infer<typeof PresenceCleanupSchedule>;

export const PresenceClient = __t.object("PresenceClient", {
  connectionId: __t.connectionId(),
  presenceId: __t.u64(),
  get clientType() {
    return ClientType;
  },
  clientVersion: __t.string(),
  joinedAt: __t.timestamp(),
  lastHeartbeat: __t.timestamp(),
});
export type PresenceClient = __Infer<typeof PresenceClient>;

export const PresenceState = __t.object("PresenceState", {
  presenceId: __t.u64(),
  userIdentity: __t.identity(),
  displayName: __t.string(),
  avatarColor: __t.string(),
  get actorType() {
    return ActorType;
  },
  agentType: __t.option(__t.string()),
  get clientType() {
    return ClientType;
  },
  clientVersion: __t.string(),
  get status() {
    return PresenceStatus;
  },
  statusMessage: __t.option(__t.string()),
  joinedAt: __t.timestamp(),
  lastHeartbeat: __t.timestamp(),
  isConnected: __t.bool(),
  activeSessionId: __t.option(__t.u64()),
  associatedTwinId: __t.option(__t.string()),
});
export type PresenceState = __Infer<typeof PresenceState>;

// The tagged union or sum type for the algebraic type `PresenceStatus`.
export const PresenceStatus = __t.enum("PresenceStatus", {
  Online: __t.unit(),
  Away: __t.unit(),
  Busy: __t.unit(),
  DoNotDisturb: __t.unit(),
});
export type PresenceStatus = __Infer<typeof PresenceStatus>;

export const RetiredService = __t.object("RetiredService", {
  identity: __t.identity(),
});
export type RetiredService = __Infer<typeof RetiredService>;

export const Session = __t.object("Session", {
  sessionId: __t.u64(),
  scope: __t.option(__t.string()),
  get sessionType() {
    return SessionType;
  },
  title: __t.option(__t.string()),
  createdBy: __t.identity(),
  createdAt: __t.timestamp(),
  get status() {
    return SessionStatus;
  },
  get access() {
    return SessionAccess;
  },
  metadataJson: __t.option(__t.string()),
  canonicalKey: __t.option(__t.string()),
});
export type Session = __Infer<typeof Session>;

// The tagged union or sum type for the algebraic type `SessionAccess`.
export const SessionAccess = __t.enum("SessionAccess", {
  Open: __t.unit(),
  Private: __t.unit(),
});
export type SessionAccess = __Infer<typeof SessionAccess>;

export const SessionParticipant = __t.object("SessionParticipant", {
  id: __t.u64(),
  sessionId: __t.u64(),
  userIdentity: __t.identity(),
  presenceId: __t.u64(),
  get role() {
    return SessionRole;
  },
  isActive: __t.bool(),
  joinedAt: __t.timestamp(),
});
export type SessionParticipant = __Infer<typeof SessionParticipant>;

// The tagged union or sum type for the algebraic type `SessionRole`.
export const SessionRole = __t.enum("SessionRole", {
  Owner: __t.unit(),
  Participant: __t.unit(),
  Observer: __t.unit(),
});
export type SessionRole = __Infer<typeof SessionRole>;

// The tagged union or sum type for the algebraic type `SessionStatus`.
export const SessionStatus = __t.enum("SessionStatus", {
  Active: __t.unit(),
  Paused: __t.unit(),
  Closed: __t.unit(),
});
export type SessionStatus = __Infer<typeof SessionStatus>;

// The tagged union or sum type for the algebraic type `SessionType`.
export const SessionType = __t.enum("SessionType", {
  Default: __t.unit(),
  Onboarding: __t.unit(),
  Collaboration: __t.unit(),
  Review: __t.unit(),
  DirectMessage: __t.unit(),
});
export type SessionType = __Infer<typeof SessionType>;

export const TtsCacheCleanupSchedule = __t.object("TtsCacheCleanupSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type TtsCacheCleanupSchedule = __Infer<typeof TtsCacheCleanupSchedule>;

export const TtsCacheEntry = __t.object("TtsCacheEntry", {
  cacheKey: __t.string(),
  provider: __t.string(),
  model: __t.string(),
  voice: __t.string(),
  textPreview: __t.string(),
  mimeType: __t.string(),
  sampleRate: __t.u32(),
  audioBytes: __t.byteArray(),
  durationMs: __t.u32(),
  createdAt: __t.timestamp(),
  lastUsedAt: __t.timestamp(),
  hitCount: __t.u64(),
  blobPath: __t.option(__t.string()),
});
export type TtsCacheEntry = __Infer<typeof TtsCacheEntry>;

export const UserTokenGrant = __t.object("UserTokenGrant", {
  grantId: __t.u64(),
  requestId: __t.u64(),
  userIdentity: __t.identity(),
  agentIdentity: __t.identity(),
  audience: __t.string(),
  accessToken: __t.string(),
  expiresAtMs: __t.u64(),
  grantedAt: __t.timestamp(),
});
export type UserTokenGrant = __Infer<typeof UserTokenGrant>;

export const UserTokenRelayListPushed = __t.object("UserTokenRelayListPushed", {
  id: __t.u32(),
  pushedAt: __t.timestamp(),
});
export type UserTokenRelayListPushed = __Infer<typeof UserTokenRelayListPushed>;

export const UserTokenRelayService = __t.object("UserTokenRelayService", {
  identity: __t.identity(),
});
export type UserTokenRelayService = __Infer<typeof UserTokenRelayService>;

export const UserTokenRequestCounter = __t.object("UserTokenRequestCounter", {
  id: __t.u8(),
  nextRequestId: __t.u64(),
});
export type UserTokenRequestCounter = __Infer<typeof UserTokenRequestCounter>;

export const UserTokenRequestEvent = __t.object("UserTokenRequestEvent", {
  requestId: __t.u64(),
  agentIdentity: __t.identity(),
  userIdentity: __t.identity(),
  sessionId: __t.u64(),
  audience: __t.string(),
  requestedAt: __t.timestamp(),
});
export type UserTokenRequestEvent = __Infer<typeof UserTokenRequestEvent>;

// The tagged union or sum type for the algebraic type `Visibility`.
export const Visibility = __t.enum("Visibility", {
  Public: __t.unit(),
  Private: __t.unit(),
  Specific: __t.unit(),
});
export type Visibility = __Infer<typeof Visibility>;

export const WebCursorState = __t.object("WebCursorState", {
  presenceId: __t.u64(),
  sessionId: __t.u64(),
  context: __t.string(),
  get position() {
    return CursorPosition;
  },
  hoveredElementType: __t.option(__t.string()),
  hoveredElementId: __t.option(__t.string()),
  lastUpdate: __t.timestamp(),
});
export type WebCursorState = __Infer<typeof WebCursorState>;

export const WorkosOrgConfig = __t.object("WorkosOrgConfig", {
  id: __t.u32(),
  workosOrgId: __t.string(),
  configuredAt: __t.timestamp(),
});
export type WorkosOrgConfig = __Infer<typeof WorkosOrgConfig>;

